import { render, staticRenderFns } from "./TablaSimSolicitudes.vue?vue&type=template&id=42e29d02&"
import script from "./TablaSimSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./TablaSimSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./TablaSimSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42e29d02', component.options)
    } else {
      api.reload('42e29d02', component.options)
    }
    module.hot.accept("./TablaSimSolicitudes.vue?vue&type=template&id=42e29d02&", function () {
      api.rerender('42e29d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SIMSolicitudes/TablaSimSolicitudes.vue"
export default component.exports